/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integration_ImportingInputs */

const en_integration_importing = /** @type {(inputs: Integration_ImportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adding your selected files…`)
};

const es_integration_importing = /** @type {(inputs: Integration_ImportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadiendo los archivos seleccionados…`)
};

/**
* | output |
* | --- |
* | "Adding your selected files…" |
*
* @param {Integration_ImportingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const integration_importing = /** @type {((inputs?: Integration_ImportingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integration_ImportingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_integration_importing(inputs)
	return en_integration_importing(inputs)
});